import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/select-dealer/intro_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1222}
              height={559}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#F15D20" }}>Introduction</span>
            </h2>
            <p>
              Select Dealer Service aims to help Dealer clients identify and
              improve on lost opportunities and falling efficiency in the
              organization. They also help clients restructure, and delivery
              more simplified practices, products, processes and training for
              the entire company.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
